import styled from "@emotion/native";
import { Accessory as Accessory_, Main as Main_ } from "../../styles";

export const Main = styled(Main_)({
	flex: 1,
});

export const Accessory = styled(Accessory_)({});
